import { render, staticRenderFns } from "./AdminPresentationTime.vue?vue&type=template&id=23d0b892"
import script from "./AdminPresentationTime.vue?vue&type=script&lang=js"
export * from "./AdminPresentationTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports